import { render, staticRenderFns } from "./KegBatchIndex.vue?vue&type=template&id=789ce0a0&scoped=true"
import script from "./KegBatchIndex.vue?vue&type=script&lang=js"
export * from "./KegBatchIndex.vue?vue&type=script&lang=js"
import style0 from "./KegBatchIndex.vue?vue&type=style&index=0&id=789ce0a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789ce0a0",
  null
  
)

export default component.exports